/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmDatovaSchranka extends GContentBase<SeznamAdmDatovaSchrankaObj> {
        private seznamObj: SeznamAdmDatovaSchrankaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmDatovaSchrankaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmDatovaSchranka",
                contentCaption: "jres:33000645", //RC 33000645 : Datov� schr�nky
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{mailbox}"
                },
                gridSettings: {
                    columnOrder: "mailbox,nazev,poznamka,dat_zmena,zmenu_provedl,nazev_su,nazev_su_main,jmeno,otisk"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmDatovaSchrankaObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDatovaSchranka", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmDatovaSchranka",
                newRecord: isNew,
                mailbox: isNew == true ? null : data.mailbox

            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actAdmSeznamAdmMotorZpracovaniEpa: {
                    icon: "fa-link",
                    caption: "jres:33001024",
                    run: (ev, ctx) => {
                        this.openAdmMotorZpracovaniEpa();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actAdmSeznamAdmMotorZpracovaniEpa }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actAddToComparison*", "-", "actAdmSeznamAdmMotorZpracovaniEpa*"])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmDatovaSchranka.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.mailbox),
                nazev: data.nazev
            }
        }

        private openAdmMotorZpracovaniEpa() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmMotorZpracovaniEPA", {
                    ID: "SeznamAdmMotorZpracovaniEPA",
                    mailbox: activeRow.mailbox,
                    typ_mbx: activeRow.typ_mbx,
                })
        }
    }
}
